// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2vBQC","tab":"ProcedureTabs_tab__ZWRI1"};